<template>
  <div class="resource_subject_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveSuite">保存</el-button>
    </div>
    <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="resource_subject_content">
        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="名称" prop="name">
            <el-input v-model="formData.name" :minlength="1" :maxlength="20" placeholder="请输入名称（1-20个字符）"></el-input>
          </el-form-item>
          <el-form-item label="序号" prop="orderNo">
            <el-input-number v-model="formData.orderNo" controls-position="right" :precision="0" :min="1" :max="10000" :step="1" :step-strictly="true"></el-input-number>
          </el-form-item>
          <el-form-item label="是否背诵" prop="isMain">
            <el-radio-group v-model="formData.isMain">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="说明" prop="remark">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="formData.remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize'
  import {getGradeAtlasDetailInfoById, addAtlasDetail, editAtlasDetail} from '@/api/resourceMap'

  export default {
    name: "resourceLessonAdd",
    data() {
      return {
        atlasId: sessionStorage.getItem('atlasId'),
        pidAtlasId: this.$route.query.pidAtlasId,
        courseId: this.$route.query.courseId,
        pAtlasJson: {},
        formData: {
          name: '',
          orderNo: 1,
          isMain: 1,
          remark: ''
        },
        rules: {
          name: [
            { required: true, trigger: 'blur', message: '请输入名称' },
            { min: 1, max: 20, message: "输入长度在1到20个字符", trigger: "change" }
          ],
          orderNo: [
            { required: true, trigger: 'blur', message: '请选择序号' }
          ],
          isMain: [
            { required: true }
          ]
        }
      }
    },
    mixins: [windowResize],
    created() {
      this.getGradeAtlasDetailInfoById();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getGradeAtlasDetailInfoById() {
        getGradeAtlasDetailInfoById({gradeAtlasId: this.pidAtlasId || this.courseId}).then(data => {
          this.pAtlasJson = data;
          if (this.courseId) {
            this.formData = {
              name: data.name,
              orderNo: data.orderNo,
              isMain: data.isMain,
              remark: data.remark
            }
          }
        })
      },
      saveSuite() {
        this.$refs.form.validate(isValid => {
          if (isValid) {
            new Promise(resolve => {
              if (this.courseId) {
                let query = {
                  isMain: this.formData.isMain,
                  name: this.formData.name,
                  orderNo: this.formData.orderNo,
                  id: this.pAtlasJson.id,
                  remark: this.formData.remark,
                  type: this.pAtlasJson.type
                };
                editAtlasDetail(query).then(resolve)
              } else {
                let query = {
                  atlasId: this.pAtlasJson.atlasId,
                  isMain: this.formData.isMain,
                  level: this.pAtlasJson.level + 1,
                  name: this.formData.name,
                  orderNo: this.formData.orderNo,
                  pid: this.pAtlasJson.id,
                  remark: this.formData.remark,
                  type: 3
                };
                addAtlasDetail(query).then(resolve)
              }
            }).then(() => {
              this.$message.success(`${this.courseId ? '编辑成功' : '新增成功'}`);
              window.setTimeout(() => {
                this.goBack();
              }, 500);
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .resource_subject_add_wrap {
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .resource_subject_box {
      @include scrollBar;

      .resource_subject_content {
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceLessonAdd.vue